import React, { useEffect } from 'react';
import { useState } from 'react';
import { CommissionReportPresentational } from './commission-report-presentational';

// const PAGE_SIZE = 5;
import moment from 'moment';
import Axios from 'axios';
import { appConstant, apiUrl, colorsList } from '@constants';
import { getAuthToken, getAuthKey, setStartDate, devlog, getRandomColors } from '@helpers';

import Selectors from '@sharedComponent/app-action-reducer/selectors';
import { connect } from 'react-redux';

const dateFormat = 'MM/DD/YYYY';

const CommissionReportFunctional = ({ userDetails }) => {
	const [chartLoading, setchartLoading] = useState(false);
	const [tableLoading, settableLoading] = useState(false);
	const [state, setState] = useState({
		lineActive: false,
		barActive: true,
		chartType: 'bar',
		zoomicontype: 'activeexit',
		dataSource: [],
	});

	const handleChange = (label, value) => {
		setState({
			...state,
			[label]: value,
		});
	};

	const [commissionData, setCommissionData] = useState({
		startDate: moment(setStartDate('LAST')).format(dateFormat),
		endDate: new Date(),
		numberOfObjectsPerPage: 5,
		pageNumber: 1,
		dateFilter: 'LAST',
		chartDataType: 'Sales',
		labels: [],
		datasetsTemp: [],
		campaignList: [],
		campaignValue: [],
		datasets: [],
	});

	const handleCommission = (label, value, multiple = false, multipleData) => {
		const data = multiple ? { ...multipleData } : { [label]: value };
		setCommissionData({
			...commissionData,
			...data,
		});
	};

	const dataRangeChanged = (value) => {
		let request = {};
		if (value && value[0] && value[0] !== '') {
			setCommissionData({
				...commissionData,
				startDate: value[0],
			});
			request.startDate = value[0];
		} else {
			request.startDate = commissionData.startDate;
		}

		if (value && value[1] && value[1] !== '') {
			setCommissionData({
				...commissionData,
				endDate: value[1],
			});
			request.endDate = value[1];
		} else {
			request.endDate = commissionData.endDate;
		}
		request.chartDataType = commissionData.chartDataType || 'Clicks';
		request.numberOfObjectsPerPage = commissionData.numberOfObjectsPerPage || 5;
		request.pageNumber = commissionData.pageNumber || 1;

		getCommissionReportData(request);
		getCommissionChartData(request);
	};

	const getCommissionReportData = async (request) => {
		const authToken = await getAuthToken();
		const authKey = await getAuthKey();
		devlog(authKey);
		settableLoading(true);
		Axios.get(`${appConstant.domain + apiUrl.GET_COMMISSION_REPORT_TABLE}`, {
			headers: { Authorization: authToken },
			params: {
				authKey: authKey,
				// chartDataType: request.chartDataType || 'Clicks',
				startDate: moment(request.startDate).format(dateFormat) || moment(new Date().setDate(new Date().getDate() - 7)).format(dateFormat),
				endDate: moment(request.endDate).format(dateFormat) || moment(new Date()).format(dateFormat),
				numberOfObjectsPerPage: request.numberOfObjectsPerPage || 5,
				pageNumber: request.pageNumber || 1,
			},
		})
			.then((response) => {
				if (response.data.success) {
					setState({
						...state,
						dataSource: response.data.messages.message.data,
					});
				}
				settableLoading(false);
			})
			.catch(() => {
				settableLoading(false);
			});
	};

	const getCommissionChartData = async (request) => {
		const authToken = await getAuthToken();

		const authKey = await getAuthKey();
		setchartLoading(true);
		Axios.get(`${appConstant.domain + apiUrl.GET_COMMISSION_CHAERT}`, {
			headers: { Authorization: authToken },
			params: {
				authKey: authKey,
				chartOptions: request.chartDataType || 'Sales',
				startDate: moment(request.startDate).format(dateFormat) || moment(new Date().setDate(new Date().getDate() - 7)).format(dateFormat),
				endDate: moment(request.endDate).format(dateFormat) || moment(new Date()).format(dateFormat),
				numberOfObjectsPerPage: request.numberOfObjectsPerPage || 5,
				pageNumber: request.pageNumber || 1,
			},
		})
			.then((response) => {
				// if (response.data.result == 'SUCCESS') {
				let labels = [];
				let datasets = [];
				new Promise((resolve) => {
					labels = response.data && response.data.messages && response.data.messages.labels ? response.data.messages.labels : [];

					let labe = [];
					labels.forEach((e, index) => {
						labe[index] = moment(e).format(dateFormat);
					});
					let campaignList = (response.data && response.data.messages && response.data.messages.campaignName) || [];
					datasets =
						response.data && response.data.messages && response.data.messages.chartDateSets ? response.data.messages.chartDateSets : [];
					if (
						response.data &&
						response.data.messages &&
						response.data.messages.chartDateSets &&
						response.data.messages.chartDateSets.length > 0
					) {
						datasets.map((value, i) => {
							let random = colorsList[i] || getRandomColors();
							value.type = state.chartType || 'line';
							value.fill = false;
							value.backgroundColor = random;
							value.borderColor = random;
							value.hoverBackgroundColor = random;
							value.hoverBorderColor = random;
							value.borderWidth = 0;
							value.maxBarThickness = 15;
							value.barThickness = 5;
							value.barPercentage = 0.2;
							value.categoryPercentage = 0.2;
							return value;
						});

						resolve({ labels: labe, datasets, campaignList });
					} else {
						resolve({ labels, datasets, campaignList });
					}
				})
					.then((data) => {
						setCommissionData({
							...commissionData,
							...request,
							campaignList: data.campaignList || [],
							labels: data.labels || [],
							campaignValue: ['ALL'],
							datasets: data.datasets || [],
							datasetsTemp: data.datasets || [],
						});
						setchartLoading(false);
					})
					.catch(() => {
						setchartLoading(false);
					});
			})
			.catch(() => {
				setchartLoading(false);
			});
	};

	const changeChartType = (label, value) => {
		let dataArr = commissionData.datasets || [];
		dataArr.map((e) => {
			e.type = value;
			return e;
		});
		handleCommission('datasets', dataArr);
		handleChange(label, value);
	};

	const handleChartDataType = (label, value) => {
		let request = {
			...commissionData,
			[label]: value,
		};
		getCommissionReportData(request);
		handleCommission(label, value);
	};

	const onShowSizeChange = (index, size = 5) => {};

	const onPaginationChange = (index, size = 5) => {};

	const datefilter = (value) => {
		let startDate = setStartDate(value);

		handleCommission(null, null, true, {
			dateFilter: value,
			startDate: moment(startDate).format(dateFormat),
			endDate: moment(new Date()).format(dateFormat),
		});
		let request = {
			...commissionData,
			dateFilter: value,
			startDate: moment(startDate).format(dateFormat),
			endDate: moment(new Date()).format(dateFormat),
		};
		getCommissionChartData(request);
		getCommissionReportData(request);
	};

	const handleCampainList = (value) => {
		let camapaign = [];
		new Promise((resolve) => {
			let arr = [];
			if (value[value.length - 1] === 'ALL') {
				camapaign = commissionData.campaignList || ['ALL'];
				resolve(commissionData.datasets);
			} else {
				camapaign = [];
				value.forEach((datas) => {
					commissionData.datasets.forEach((values) => {
						if (values.label === datas) {
							arr.push(values);
							camapaign.push(datas);
						}
					});
				});
				resolve(arr);
			}
		}).then((arrays) => {
			handleCommission(null, null, true, {
				campaignValue: camapaign || [],
				datasetsTemp: arrays || [],
			});
		});
	};

	useEffect(() => {
		getCommissionReportData(commissionData);
		getCommissionChartData(commissionData);
	}, []);

	return (
		<CommissionReportPresentational
			state={state}
			handleCommission={handleCommission}
			handleChartDataType={handleChartDataType}
			handleChange={handleChange}
			changeChartType={changeChartType}
			onShowSizeChange={onShowSizeChange}
			onPaginationChange={onPaginationChange}
			handleCampainList={handleCampainList}
			datefilter={datefilter}
			dataRangeChanged={dataRangeChanged}
			userDetails={userDetails}
			commissionData={commissionData}
			loaders={{
				chartLoading,
				tableLoading,
			}}
		/>
	);
};

const mapStateToProps = (state) => {
	return {
		userDetails: Selectors.userDetails(state),
	};
};

const Connected = connect(mapStateToProps, null)(CommissionReportFunctional);

export default Connected;
